export default "__VITE_ASSET__DUyQAriY__"